import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { history } from "../enhancers/middlewares/router";
import data from "./data";

export default combineReducers({
    router: connectRouter(history),
    // status,
    data
});
